// import React, { useEffect, useState } from "react";
// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
// import axios from "axios";
// import HOST_URL from "../../../utils/Url";
// import Card from "@mui/material/Card";
// import {
//   Grid,
//   Box,
//   Button,
//   Divider,
//   Stack,
//   TextField,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   FormControl,
//   RadioGroup,
//   Radio,
//   Autocomplete,
//   ListItemText,
//   Modal,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import Switch from "@mui/material/Switch";
// import { useNavigate, useLocation } from "react-router-dom";
// import Chip from "@mui/material/Chip";
// import { useTranslation } from "react-i18next";
// import Paper from "@mui/material/Paper";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import CircularProgress from "@mui/material/CircularProgress";
// import api from "../../../utils/Url";
// import { useFormik } from "formik";
// import CustomLabel from "../../../CustomLable";
// import DownloadIcon from "@mui/icons-material/Download";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import Languages from "../../../Languages";
// import { Language } from "react-transliterate";
// import "react-transliterate/dist/index.css";
// import TranslateTextField from "../../../TranslateTextField";
// import moment from "moment";
// import { jsPDF } from "jspdf";
// import * as XLSX from "xlsx";
// import nopdf from '../../../assets/images/imagepreview.jpg';




// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };
// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// export default function FuelConsumption() {
//   const [zones, setZones] = useState([]);
//   const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null); // Initialize timerCheck state
//   const [columns, setColumns] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [visible, setVisible] = useState(false);
//   const { t } = useTranslation();
//   const [lang, setLang] = useState<Language>("en");
//   const [option, setOption] = useState([
//     { value: "-1", label: "Vehicle Type" },
//   ]);
//   const [VnoOption, setVnoOption] = useState([
//     { value: -1, label: t("text.itemMasterId") },
//   ]);

//   const [isPrint, setPrint] = useState([]);

//   const [selectedFormat, setSelectedFormat] = useState<any>("pdf");

//   const [isChecked, setIsChecked] = useState(false);

//   const [vNO, setVno] = useState([]);

//   const [vType, setVType] = useState([]);

//   const [Period, setPeriod] = useState([{ value: -1, label: "Select Period" }]);

//   const [Shows, setShows] = useState<any>(false);
//   const [IsRep, setRep] = useState<any>("");

//   const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSelectedFormat((event.target as HTMLInputElement).value);
//   };

//   const downloadExcel = () => {
//     if (!isPrint || isPrint.length === 0) {
//       console.error("No data to export to Excel.");
//       return;
//     }

//     const ws = XLSX.utils.json_to_sheet(isPrint);

//     const headers = Object.keys(isPrint[0]);

//     headers.forEach((header, index) => {
//       const cellAddress = `${String.fromCharCode(65 + index)}1`;
//     });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

//     XLSX.writeFile(wb, "Vehicle_data.xlsx");
//   };

//   // Function to download PDF
//   const downloadPDF = async () => {
//     const collectData = {
//       Str1: "",
//       Str2: isChecked ? "y" : "n",
//       Str3: "",
//       Str4: "",
//       Str5: "",
//       Str6: "",
//       intvalue1: 0,
//       intvalue2: 0,
//       intvalue3: 0,
//       intvalue4: 0,
//       intnotnullvalue1: 0,
//       intnotnullvalue2: 0,
//       intnotnullvalue3: 0,
//       list1: vNO ? vNO : [],
//       listInt1: vType ? vType : [],
//       list2: [],
//       listInt2: [],
//       listInt12: [],
//       date1: formik.values.startDate
//         ? formik.values.startDate
//         : formik.values.fromDate,
//       date2: formik.values.endDate
//         ? formik.values.endDate
//         : formik.values.toDate,
//       date3: null,
//       date4: null,
//       dec1: null,
//       dec2: null,
//       dec3: null,
//       dec4: null,
//       Flag: true,
//       Data: "",
//       Success: false,
//       Error: "",
//       SelectPerindex: formik.values.index,
//       selectedPeriod: {
//         index: formik.values.index || 2,
//         startDate: formik.values.startDate || previousDate,
//         endDate: formik.values.endDate || previousDate,
//         daysOnly: formik.values.daysOnly || true,
//         displayLabel: formik.values.displayLabel || "Yesterday",
//       },
//       listPeriod: Period,
//       SelectPerindex1: 0,
//       selectedPeriod1: {
//         index: 0,
//         startDate: previousDate,
//         endDate: previousDate,
//         daysOnly: false,
//         displayLabel: "",
//       },
//       listPeriod1: [],
//       Show: false,
//       EmpName: "",
//       ZoneName: "",
//       DepartmentName: "",
//       ExportOption: ".pdf",
//       All: false,
//       ConditionStr1: "Skip Records speed 0 and distance 0",
//       ConditionStr2: "",
//       Condition1: false,
//       Condition2: false,
//       ExpOption: [
//         {
//           ext: ".pdf",
//           extname: "Pdf",
//         },
//         {
//           ext: ".xls",
//           extname: "Excel",
//         },
//       ],
//       cancel: {
//         waitHandle: {
//           handle: {},
//           safeWaitHandle: {},
//         },
//       },
//     };
//     // console.log("collectData " + JSON.stringify(collectData));
//     const response = await api.post(
//       `VehicleMoving/VehicleFuelConsumenew`,
//       collectData
//     );


//     if (response) {

//       const base64Data = response.data;


//       const byteCharacters = atob(base64Data);
//       const byteArrays = [];


//       for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
//         const slice = byteCharacters.slice(offset, offset + 1024);
//         const byteNumbers = new Array(slice.length);
//         for (let i = 0; i < slice.length; i++) {
//           byteNumbers[i] = slice.charCodeAt(i);
//         }
//         byteArrays.push(new Uint8Array(byteNumbers));
//       }


//       const blob = new Blob(byteArrays, { type: "application/pdf" });


//       const url = URL.createObjectURL(blob);


//       const link = document.createElement("a");
//       link.href = url;
//       link.download = "FuelConsumption.pdf";
//       document.body.appendChild(link);
//       link.click();


//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);


//       //console.log('Printdata',data)
//       // setShows(true);
//       // setRep(response.data);

//     }
//   };
//   // Handle Download Button Click
//   const handleDownload = () => {
//     if (selectedFormat === "excel") {
//       downloadExcel();
//     } else if (selectedFormat === "pdf") {
//       downloadPDF();
//     }
//   };

//   let navigate = useNavigate();
//   // const { t } = useTranslation();

//   useEffect(() => {
//     getData();
//     getVehicleNo();
//     getPeriod();
//   }, []);

//   const getPeriod = () => {
//     api.get(`Period/GetPeriods?type=Period&daysOnly=false`).then((res) => {
//       const arr = res?.data?.map((item: any) => ({
//         label: item?.displayLabel,
//         value: item?.index,
//         startDate: item?.startDate,
//         endDate: item?.endDate,
//         daysOnly: item?.daysOnly,
//         index: item?.index,
//         displayLabel: item?.displayLabel
//       }));
//       setPeriod(arr);
//     });
//   };

//   const getData = () => {
//     const collectData = {
//       vehicleTypeId: -1,
//       vehicleTypename: "",
//     };
//     api.post(`VehicleType/GetVehicleType`, collectData).then((res) => {
//       const arr = res?.data?.data.map((item: any) => ({
//         label: item.vehicleTypename,
//         value: item.vehicleTypeId,
//       }));
//       setOption(arr);
//     });
//   };

//   const getVehicleNo = () => {
//     const collectData = {
//       orderby: "",
//       pageNo: 0,
//       pageSize: 0,
//       intnotnullvalue1: 0,
//       userId: "",

//       str1: "",
//       str2: "",
//       str3: "",
//       str4: "",
//       str5: "",
//       intvalue1: 0,
//       intvalue2: 0,
//       intvalue3: 0,
//       intvalue4: 0,
//       intnotnullvalue2: 0,
//       intnotnullvalue3: 0,
//       date1: new Date().toISOString(),
//       date2: new Date().toISOString(),
//       date3: new Date().toISOString(),
//       date4: new Date().toISOString(),
//       dec1: 0,
//       dec2: 0,
//       dec3: 0,
//       dec4: 0,
//       flag: true,
//       data: "",
//       success: true,
//       error: "",
//       selectPerindex: 0,
//       show: true,
//     };
//     api.post(`Dashboard/GetvVehicleNo`, collectData).then((res) => {
//       const arr = res?.data?.data.map((item: any) => ({
//         label: item.vehicleNo,
//         value: item.vehicleNo,
//       }));
//       setVnoOption(arr);
//     });
//   };

//   let currentDate = new Date();

//   currentDate.setDate(currentDate.getDate() - 1);

//   let previousDate = currentDate.toISOString();

//   const fetchZonesData = async () => {
//     try {
//       const collectData = {
//         Str1: "",
//         Str2: isChecked ? "y" : "n",
//         Str3: "",
//         Str4: "",
//         Str5: "",
//         Str6: "",
//         intvalue1: 0,
//         intvalue2: 0,
//         intvalue3: 0,
//         intvalue4: 0,
//         intnotnullvalue1: 0,
//         intnotnullvalue2: 0,
//         intnotnullvalue3: 0,
//         list1: vNO ? vNO : [],
//         listInt1: vType ? vType : [],
//         list2: [],
//         listInt2: [],
//         listInt12: [],
//         date1: formik.values.startDate
//           ? formik.values.startDate
//           : formik.values.fromDate,
//         date2: formik.values.endDate
//           ? formik.values.endDate
//           : formik.values.toDate,
//         date3: null,
//         date4: null,
//         dec1: null,
//         dec2: null,
//         dec3: null,
//         dec4: null,
//         Flag: true,
//         Data: "",
//         Success: false,
//         Error: "",
//         SelectPerindex: formik.values.index,
//         selectedPeriod: {
//           index: formik.values.index || 2,
//           startDate: formik.values.startDate || previousDate,
//           endDate: formik.values.endDate || previousDate,
//           daysOnly: formik.values.daysOnly || true,
//           displayLabel: formik.values.displayLabel || "Yesterday",
//         },
//         listPeriod: Period,
//         SelectPerindex1: 0,
//         selectedPeriod1: {
//           index: 0,
//           startDate: previousDate,
//           endDate: previousDate,
//           daysOnly: false,
//           displayLabel: "",
//         },
//         listPeriod1: [],
//         Show: true,
//         EmpName: "",
//         ZoneName: "",
//         DepartmentName: "",
//         ExportOption: ".pdf",
//         All: false,
//         ConditionStr1: "Skip Records speed 0 and distance 0",
//         ConditionStr2: "",
//         Condition1: false,
//         Condition2: false,
//         ExpOption: [
//           {
//             ext: ".pdf",
//             extname: "Pdf",
//           },
//           {
//             ext: ".xls",
//             extname: "Excel",
//           },
//         ],
//         cancel: {
//           waitHandle: {
//             handle: {},
//             safeWaitHandle: {},
//           },
//         },
//       };
//       const response = await api.post(
//         `VehicleMoving/VehicleFuelConsumenew`,
//         collectData
//       );
//       const data = response?.data;

//       const Print = data.map((item: any, index: any) => ({
//         ...item,
//       }));
//       setPrint(Print);
//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones(zonesWithIds);
//       setIsLoading(false);

//       if (data.length > 0) {
//         const columns: GridColDef[] = [
//           // {
//           //   field: "serialNo",
//           //   headerName: t("text.SrNo"),
//           //   flex: 1,
//           //   headerClassName: "MuiDataGrid-colCell",
//           // },
//           {
//             field: "trackDate",
//             headerName: t("text.Date"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             renderCell: (params) => {
//               return moment(params.row.trackDate).format("DD-MM-YYYY");
//             },
//             cellClassName: "wrap-text",  // Added here
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",  // Added here
//           },
//           {
//             field: "vehicleType",
//             headerName: t("text.VehicleType"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",  // Added here
//           },
//           {
//             field: "distanceKM",
//             headerName: t("text.DistanceKm"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             align: 'right',
//             headerAlign: 'right',
//             cellClassName: "wrap-text",  // Added here
//             // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
//           },
//           {
//             field: "avgSpeed",
//             headerName: t("text.avgSpeed"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             align: 'right',
//             headerAlign: 'right',
//             cellClassName: "wrap-text",  // Added here
//             // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
//           },
//           {
//             field: "runningIdleTime",
//             headerName: t("text.TimeConsuption"),
//             flex: 1.5,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text",  // Added here
//           },
//           {
//             field: "kmPerLitre",
//             headerName: t("text.MileageKmLtr"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             align: 'right',
//             headerAlign: 'right',
//             cellClassName: "wrap-text",  // Added here
//             // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
//           },
//           {
//             field: "fuelConsumption",
//             headerName: t("text.FuelConsumption"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             align: 'right',
//             headerAlign: 'right',
//             cellClassName: "wrap-text",  // Added here
//             // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
//           },
//         ];
//         setColumns(columns as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       // setLoading(false);
//     }
//   };

//   const adjustedColumns = columns.map((column: any) => ({
//     ...column,
//   }));

//   const styles = `
//   .wrap-text {
//     white-space: normal !important;
//     word-wrap: break-word !important;
//     overflow-wrap: break-word !important;
//   }
// `;

//   document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

//   const formik = useFormik({
//     initialValues: {
//       genderID: -1,
//       genderName: "",
//       genderCode: "",
//       fromDate: "",
//       toDate: "",
//       parentId: 0,
//       startDate: "",
//       endDate: "",
//       daysOnly: false,
//       displayLabel: "",
//       index: 0,
//     },
//     onSubmit: async (values) => {
//       //   const response = await api.post(
//       //     `Gender/AddUpdateGenderMaster`,
//       //     values
//       //   );
//       //   try {
//       //     setToaster(false);
//       //     toast.success(response.data.mesg);
//       //     navigate("/master/GenderMaster");
//       //   } catch (error) {
//       //     setToaster(true);
//       //     toast.error(response.data.mesg);
//       //   }
//     },
//   });

//   return (
//     <>
//       <Card
//         style={{
//           width: "100%",
//           // height: "100%",
//           backgroundColor: "#E9FDEE",
//           // border: ".5px solid #FF7722 ",
//           marginTop: "3vh",
//         }}
//       >
//         <Paper
//           sx={{
//             width: "100%",
//             overflow: "hidden",
//             "& .MuiDataGrid-colCell": {
//               backgroundColor: `var(--grid-headerBackground)`,
//               color: `var(--grid-headerColor)`,
//               fontSize: 17,
//               fontWeight: 900,
//             },
//           }}
//           style={{ padding: "10px" }}
//         >
//           <ConfirmDialog />

//           <Typography
//             gutterBottom
//             variant="h5"
//             component="div"
//             sx={{ padding: "20px" }}
//             align="left"
//           >
//             {t("text.FuelConsumption")}
//           </Typography>
//           <Divider />

//           <Box height={10} />

//           <Grid item xs={12} container spacing={2} sx={{ marginTop: "3vh" }}>
//             <Grid item xs={12} sm={4} lg={4}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={isChecked}
//                     onChange={(e) => {
//                       setIsChecked(e.target.checked);
//                     }}
//                   />
//                 }
//                 label="For All Vehicles"
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} lg={4}>
//               <FormControl component="fieldset">
//                 <RadioGroup
//                   row
//                   value={selectedFormat}
//                   onChange={handleFormatChange}
//                 >
//                   <FormControlLabel
//                     value="pdf"
//                     control={<Radio />}
//                     label="PDF"
//                   />
//                   <FormControlLabel
//                     value="excel"
//                     control={<Radio />}
//                     label="Excel"
//                   />
//                 </RadioGroup>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4} lg={4}></Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Autocomplete
//                 disablePortal
//                 id="combo-box-demo"
//                 options={[{ value: -1, label: "Custom" }].concat(Period)}
//                 fullWidth
//                 size="small"
//                 onChange={(event, newValue: any) => {
//                   // console.log(newValue?.value);

//                   if (newValue && newValue.value !== undefined) {
//                     if (newValue.value === -1) {
//                       formik.setFieldValue("parentId", newValue.value || null);
//                     } else {
//                       formik.setFieldValue("index", newValue.index || null);
//                       formik.setFieldValue(
//                         "startDate",
//                         newValue.startDate || ""
//                       );
//                       formik.setFieldValue("endDate", newValue.endDate || "");
//                       formik.setFieldValue(
//                         "daysOnly",
//                         newValue.daysOnly || false
//                       );
//                       formik.setFieldValue(
//                         "displayLabel",
//                         newValue.label || ""
//                       );
//                     }
//                   } else {
//                     // Handle case when newValue is null or undefined
//                     console.error("newValue is null or undefined");
//                     // Optionally reset form fields or handle the case here
//                   }
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label={
//                       <CustomLabel text={t("text.Period")} required={false} />
//                     }
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <TextField
//                 type="date"
//                 id="fromDate"
//                 name="fromDate"
//                 label={
//                   <CustomLabel text={t("text.FromDate")} required={false} />
//                 }
//                 value={formik.values.fromDate}
//                 placeholder={t("text.FromDate")}
//                 size="small"
//                 fullWidth
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 InputLabelProps={{ shrink: true }}
//                 disabled={formik.values.parentId !== -1}
//                 InputProps={{
//                   readOnly: formik.values.parentId !== -1,
//                 }}
//               />
//             </Grid>

//             {/* To Date Input */}
//             <Grid xs={12} sm={4} md={4} item>
//               <TextField
//                 type="date"
//                 id="toDate"
//                 name="toDate"
//                 label={<CustomLabel text={t("text.ToDate")} required={false} />}
//                 value={formik.values.toDate}
//                 placeholder={t("text.ToDate")}
//                 size="small"
//                 fullWidth
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 InputLabelProps={{ shrink: true }}
//                 disabled={formik.values.parentId !== -1}
//                 InputProps={{
//                   readOnly: formik.values.parentId !== -1,
//                 }}
//               />
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Autocomplete
//                 multiple
//                 disablePortal
//                 id="combo-box-demo"
//                 options={option}
//                 fullWidth
//                 size="small"
//                 onChange={(event, newValue: any) => {
//                   // console.log(newValue?.value);
//                   const selectedVType = newValue.map((item: any) => item.value);
//                   setVType(selectedVType);
//                 }}
//                 disableCloseOnSelect
//                 renderOption={(props, option, { selected }) => (
//                   <li {...props}>
//                     <Checkbox style={{ marginRight: 8 }} checked={selected} />
//                     <ListItemText primary={option.label} />
//                   </li>
//                 )}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label={
//                       <CustomLabel
//                         text={t("text.VehicleType")}
//                         required={false}
//                       />
//                     }
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} lg={4}>
//               <Autocomplete
//                 multiple
//                 disablePortal
//                 id="combo-box-demo"
//                 options={VnoOption}
//                 fullWidth
//                 size="small"
//                 onChange={(event: any, newValue: any) => {
//                   const selectedVno = newValue.map((item: any) => item.value);
//                   setVno(selectedVno);
//                 }}
//                 disableCloseOnSelect
//                 renderOption={(props, option, { selected }) => (
//                   <li {...props}>
//                     <Checkbox style={{ marginRight: 8 }} checked={selected} />
//                     <ListItemText primary={option.label} />
//                   </li>
//                 )}
//                 renderInput={(params: any) => (
//                   <TextField
//                     {...params}
//                     label={
//                       <CustomLabel
//                         text={t("text.VehicleNos1")}
//                         required={false}
//                       />
//                     }
//                   />
//                 )}
//                 popupIcon={null}
//               />
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item></Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Button
//                 type="submit"
//                 fullWidth
//                 style={{
//                   backgroundColor: `var(--header-background)`,
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 onClick={() => {
//                   const selectedPeriod = formik.values.fromDate ? formik.values.fromDate : formik.values.index;

//                   if (!selectedPeriod) {

//                     alert("Please select a period. or custom date");
//                   } else {

//                     fetchZonesData();
//                     setVisible(true);
//                   }
//                 }}
//                 startIcon={<VisibilityIcon />}
//               >
//                 Show
//               </Button>
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Button
//                 type="button"
//                 fullWidth
//                 style={{
//                   backgroundColor: `#f44336`,
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 startIcon={<RefreshIcon />}
//                 onClick={() => {
//                   formik.resetForm();
//                 }}
//               >
//                 Reset
//               </Button>
//             </Grid>

//             <Grid item xs={12} sm={4} md={4}>
//               <Button
//                 type="button"
//                 fullWidth
//                 style={{
//                   backgroundColor: "#4caf50",
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 startIcon={<DownloadIcon />}
//                 onClick={handleDownload}
//               >
//                 Download
//               </Button>
//             </Grid>
//           </Grid>

//           <Grid
//             item
//             xs={12}
//             container
//             spacing={2}
//             sx={{ marginTop: "3%", justifyContent: "center" }}
//           >
//             {visible && (
//               <Grid item xs={12} sm={12} lg={12}>
//                 {isLoading ? (
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     <CircularProgress />
//                   </div>
//                 ) : (
//                   <DataGrid
//                     rows={zones}
//                     columns={adjustedColumns}
//                     rowSpacingType="border"
//                     autoHeight
//                     slots={{
//                       toolbar: GridToolbar,
//                     }}
//                     pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                       value: size,
//                       label: `${size}`,
//                     }))}
//                     initialState={{
//                       pagination: { paginationModel: { pageSize: 5 } },
//                     }}
//                     slotProps={{
//                       toolbar: {
//                         showQuickFilter: true,
//                       },
//                     }}
//                     sx={{
//                       border: 0,
//                       "& .MuiDataGrid-columnHeaders": {
//                         backgroundColor: "#42b6f5", // Header background color
//                         color: "white", // Header text color
//                       },
//                       "& .MuiDataGrid-columnHeaderTitle": {
//                         color: "white", // Header title text color
//                         fontSize: '14px'
//                       },
//                       "& .MuiDataGrid-cell": {
//                         whiteSpace: "normal", // Ensure text wraps inside the cell
//                         wordWrap: "break-word", // Break words to avoid overflow
//                         overflowWrap: "break-word", // Ensure long words wrap correctly
//                       },
//                     }}
//                   />
//                 )}
//               </Grid>
//             )}
//           </Grid>



//           <Modal open={Shows} onClose={() => setShows(false)}>
//             <Box sx={style}>
//               {IsRep ? (
//                 <embed src={`data:application/pdf;base64,${IsRep}`} type="application/pdf" style={{ width: "100%", height: "100%" }} />
//               ) : (
//                 <img
//                   src={nopdf}
//                   alt="No Preview"
//                   style={{ width: "100%", height: "100%" }}
//                 />
//               )}
//             </Box>
//           </Modal>
//         </Paper>
//       </Card>
//       <ToastApp />
//     </>
//   );
// }
















import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
  Grid,
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  Autocomplete,
  ListItemText,
  Modal,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../utils/Url";
import { useFormik } from "formik";
import CustomLabel from "../../../CustomLable";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import moment from "moment";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import nopdf from '../../../assets/images/imagepreview.jpg';

interface OptionType {
  value: string | number;
  label: string;
}

interface CustomMultiSelectAutocompleteProps {
  options: OptionType[];
  label: string;
  onChange: (event: any, newValue: OptionType[]) => void;
  value: OptionType[];
  [key: string]: any;
}

const CustomMultiSelectAutocomplete: React.FC<CustomMultiSelectAutocompleteProps> = ({
  options,
  label,
  onChange,
  value,
  ...props
}) => {
  const allSelected = value?.length === options?.filter(opt => opt.value !== "-1" && opt.value !== -1).length;

  return (
    <Autocomplete
      multiple
      disablePortal
      size="small"
      options={options}
      value={value}
      onChange={onChange}
      disableCloseOnSelect
      renderOption={(props, option, { selected }) => {
        if (option.value === "-1" || option.value === -1) {
          return (
            <li {...props}>
              <Checkbox
                style={{ marginRight: 8 }}
                checked={allSelected}
                indeterminate={!allSelected && value?.length > 0}
              />
              <ListItemText primary="Select All" />
            </li>
          );
        }
        return (
          <li {...props}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            <ListItemText primary={option.label} />
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={<CustomLabel text={label} required={false} />}
        />
      )}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.label}
      {...props}
    />
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  height: "85%",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};
interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function FuelConsumption() {
  const [zones, setZones] = useState([]);
  const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null); // Initialize timerCheck state
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const [lang, setLang] = useState<Language>("en");
  const [option, setOption] = useState<OptionType[]>([
    { value: "-1", label: "Select All" },
  ]);
  const [VnoOption, setVnoOption] = useState<OptionType[]>([
    { value: -1, label: "Select All" },
  ]);

  const [isPrint, setPrint] = useState([]);

  const [selectedFormat, setSelectedFormat] = useState<any>("pdf");

  const [isChecked, setIsChecked] = useState(false);

  const [vNO, setVno] = useState<(string | number)[]>([]);

  const [vType, setVType] = useState<(string | number)[]>([]);

  const [Period, setPeriod] = useState([{ value: -1, label: "Select Period" }]);

  const [Shows, setShows] = useState<any>(false);
  const [IsRep, setRep] = useState<any>("");

  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat((event.target as HTMLInputElement).value);
  };

  const downloadExcel = () => {
    if (!isPrint || isPrint.length === 0) {
      console.error("No data to export to Excel.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(isPrint);

    const headers = Object.keys(isPrint[0]);

    headers.forEach((header, index) => {
      const cellAddress = `${String.fromCharCode(65 + index)}1`;
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "vehicles");

    XLSX.writeFile(wb, "Vehicle_data.xlsx");
  };

  // Function to download PDF
  const downloadPDF = async () => {
    const collectData = {
      Str1: "",
      Str2: isChecked ? "y" : "n",
      Str3: "",
      Str4: "",
      Str5: "",
      Str6: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: 0,
      intnotnullvalue1: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      list1: vNO ? vNO : [],
      listInt1: vType ? vType : [],
      list2: [],
      listInt2: [],
      listInt12: [],
      date1: formik.values.startDate
        ? formik.values.startDate
        : formik.values.fromDate,
      date2: formik.values.endDate
        ? formik.values.endDate
        : formik.values.toDate,
      date3: null,
      date4: null,
      dec1: null,
      dec2: null,
      dec3: null,
      dec4: null,
      Flag: true,
      Data: "",
      Success: false,
      Error: "",
      SelectPerindex: formik.values.index,
      selectedPeriod: {
        index: formik.values.index || 2,
        startDate: formik.values.startDate || previousDate,
        endDate: formik.values.endDate || previousDate,
        daysOnly: formik.values.daysOnly || true,
        displayLabel: formik.values.displayLabel || "Yesterday",
      },
      listPeriod: Period,
      SelectPerindex1: 0,
      selectedPeriod1: {
        index: 0,
        startDate: previousDate,
        endDate: previousDate,
        daysOnly: false,
        displayLabel: "",
      },
      listPeriod1: [],
      Show: false,
      EmpName: "",
      ZoneName: "",
      DepartmentName: "",
      ExportOption: ".pdf",
      All: false,
      ConditionStr1: "Skip Records speed 0 and distance 0",
      ConditionStr2: "",
      Condition1: false,
      Condition2: false,
      ExpOption: [
        {
          ext: ".pdf",
          extname: "Pdf",
        },
        {
          ext: ".xls",
          extname: "Excel",
        },
      ],
      cancel: {
        waitHandle: {
          handle: {},
          safeWaitHandle: {},
        },
      },
    };
    // console.log("collectData " + JSON.stringify(collectData));
    const response = await api.post(
      `VehicleMoving/VehicleFuelConsumenew`,
      collectData
    );


    if (response) {

      const base64Data = response.data;


      const byteCharacters = atob(base64Data);
      const byteArrays = [];


      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }


      const blob = new Blob(byteArrays, { type: "application/pdf" });


      const url = URL.createObjectURL(blob);


      const link = document.createElement("a");
      link.href = url;
      link.download = "FuelConsumption.pdf";
      document.body.appendChild(link);
      link.click();


      document.body.removeChild(link);
      URL.revokeObjectURL(url);


      //console.log('Printdata',data)
      // setShows(true);
      // setRep(response.data);

    }
  };
  // Handle Download Button Click
  const handleDownload = () => {
    if (selectedFormat === "excel") {
      downloadExcel();
    } else if (selectedFormat === "pdf") {
      downloadPDF();
    }
  };

  let navigate = useNavigate();
  // const { t } = useTranslation();

  useEffect(() => {
    getData();
    getVehicleNo();
    getPeriod();
  }, []);

  const getPeriod = () => {
    api.get(`Period/GetPeriods?type=Period&daysOnly=false`).then((res) => {
      const arr = res?.data?.map((item: any) => ({
        label: item?.displayLabel,
        value: item?.index,
        startDate: item?.startDate,
        endDate: item?.endDate,
        daysOnly: item?.daysOnly,
        index: item?.index,
        displayLabel: item?.displayLabel
      }));
      setPeriod(arr);
    });
  };

  const getData = () => {
    const collectData = {
      vehicleTypeId: -1,
      vehicleTypename: "",
    };
    api.post(`VehicleType/GetVehicleType`, collectData).then((res) => {
      const arr = res?.data?.data.map((item: any) => ({
        label: item.vehicleTypename,
        value: item.vehicleTypeId,
      }));
      setOption(prev => [...prev, ...arr]);
    });
  };

  const getVehicleNo = () => {
    const collectData = {
      orderby: "",
      pageNo: 0,
      pageSize: 0,
      intnotnullvalue1: 0,
      userId: "",

      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      date1: new Date().toISOString(),
      date2: new Date().toISOString(),
      date3: new Date().toISOString(),
      date4: new Date().toISOString(),
      dec1: 0,
      dec2: 0,
      dec3: 0,
      dec4: 0,
      flag: true,
      data: "",
      success: true,
      error: "",
      selectPerindex: 0,
      show: true,
    };
    api.post(`Dashboard/GetvVehicleNo`, collectData).then((res) => {
      const arr = res?.data?.data.map((item: any) => ({
        label: item.vehicleNo,
        value: item.vehicleNo,
      }));
      setVnoOption(prev => [...prev, ...arr]);
    });
  };

  let currentDate = new Date();

  currentDate.setDate(currentDate.getDate() - 1);

  let previousDate = currentDate.toISOString();

  const fetchZonesData = async () => {
    try {
      const collectData = {
        Str1: "",
        Str2: isChecked ? "y" : "n",
        Str3: "",
        Str4: "",
        Str5: "",
        Str6: "",
        intvalue1: 0,
        intvalue2: 0,
        intvalue3: 0,
        intvalue4: 0,
        intnotnullvalue1: 0,
        intnotnullvalue2: 0,
        intnotnullvalue3: 0,
        list1: vNO ? vNO : [],
        listInt1: vType ? vType : [],
        list2: [],
        listInt2: [],
        listInt12: [],
        date1: formik.values.startDate
          ? formik.values.startDate
          : formik.values.fromDate,
        date2: formik.values.endDate
          ? formik.values.endDate
          : formik.values.toDate,
        date3: null,
        date4: null,
        dec1: null,
        dec2: null,
        dec3: null,
        dec4: null,
        Flag: true,
        Data: "",
        Success: false,
        Error: "",
        SelectPerindex: formik.values.index,
        selectedPeriod: {
          index: formik.values.index || 2,
          startDate: formik.values.startDate || previousDate,
          endDate: formik.values.endDate || previousDate,
          daysOnly: formik.values.daysOnly || true,
          displayLabel: formik.values.displayLabel || "Yesterday",
        },
        listPeriod: Period,
        SelectPerindex1: 0,
        selectedPeriod1: {
          index: 0,
          startDate: previousDate,
          endDate: previousDate,
          daysOnly: false,
          displayLabel: "",
        },
        listPeriod1: [],
        Show: true,
        EmpName: "",
        ZoneName: "",
        DepartmentName: "",
        ExportOption: ".pdf",
        All: false,
        ConditionStr1: "Skip Records speed 0 and distance 0",
        ConditionStr2: "",
        Condition1: false,
        Condition2: false,
        ExpOption: [
          {
            ext: ".pdf",
            extname: "Pdf",
          },
          {
            ext: ".xls",
            extname: "Excel",
          },
        ],
        cancel: {
          waitHandle: {
            handle: {},
            safeWaitHandle: {},
          },
        },
      };
      const response = await api.post(
        `VehicleMoving/VehicleFuelConsumenew`,
        collectData
      );
      const data = response?.data;

      const Print = data.map((item: any, index: any) => ({
        ...item,
      }));
      setPrint(Print);
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
      }));
      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          // {
          //   field: "serialNo",
          //   headerName: t("text.SrNo"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          {
            field: "trackDate",
            headerName: t("text.Date"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => {
              return moment(params.row.trackDate).format("DD-MM-YYYY");
            },
            cellClassName: "wrap-text",  // Added here
          },
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",  // Added here
          },
          {
            field: "vehicleType",
            headerName: t("text.VehicleType"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",  // Added here
          },
          {
            field: "distanceKM",
            headerName: t("text.DistanceKm"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            align: 'right',
            headerAlign: 'right',
            cellClassName: "wrap-text",  // Added here
            // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
          },
          {
            field: "avgSpeed",
            headerName: t("text.avgSpeed"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            align: 'right',
            headerAlign: 'right',
            cellClassName: "wrap-text",  // Added here
            // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
          },
          {
            field: "runningIdleTime",
            headerName: t("text.TimeConsuption"),
            flex: 1.5,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",  // Added here
          },
          {
            field: "kmPerLitre",
            headerName: t("text.MileageKmLtr"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            align: 'right',
            headerAlign: 'right',
            cellClassName: "wrap-text",  // Added here
            // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
          },
          {
            field: "fuelConsumption",
            headerName: t("text.FuelConsumption"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            align: 'right',
            headerAlign: 'right',
            cellClassName: "wrap-text",  // Added here
            // valueFormatter: ({ value }) => value ? value.toFixed(2) : '',
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  const styles = `
  .wrap-text {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }
`;

  document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

  const formik = useFormik({
    initialValues: {
      genderID: -1,
      genderName: "",
      genderCode: "",
      fromDate: "",
      toDate: "",
      parentId: 0,
      startDate: "",
      endDate: "",
      daysOnly: false,
      displayLabel: "",
      index: 0,
    },
    onSubmit: async (values) => {
      //   const response = await api.post(
      //     `Gender/AddUpdateGenderMaster`,
      //     values
      //   );
      //   try {
      //     setToaster(false);
      //     toast.success(response.data.mesg);
      //     navigate("/master/GenderMaster");
      //   } catch (error) {
      //     setToaster(true);
      //     toast.error(response.data.mesg);
      //   }
    },
  });

  const handleVehicleTypeChange = (event: any, newValue: OptionType[]) => {
    if (newValue && newValue.find((option) => option.value === "-1")) {
      const allOptions: any = option.filter(opt => opt.value !== "-1");
      setVType(allOptions.map((item: any) => item.value));
      return;
    }

    const selectedVType = newValue.map(item => item.value);
    setVType(selectedVType);
  };

  const handleVehicleNoChange = (event: any, newValue: OptionType[]) => {
    if (newValue && newValue.find((option) => option.value === -1)) {
      const allOptions: any = VnoOption.filter(opt => opt.value !== -1);
      setVno(allOptions.map((item: any) => item.value));
      return;
    }

    const selectedVno = newValue.map(item => item.value);
    setVno(selectedVno);
  };

  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          // border: ".5px solid #FF7722 ",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.FuelConsumption")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Grid item xs={12} container spacing={2} sx={{ marginTop: "3vh" }}>
            <Grid item xs={12} sm={4} lg={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={(e) => {
                      setIsChecked(e.target.checked);
                    }}
                  />
                }
                label="For All Vehicles"
              />
            </Grid>

            <Grid item xs={12} sm={4} lg={4}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  value={selectedFormat}
                  onChange={handleFormatChange}
                >
                  <FormControlLabel
                    value="pdf"
                    control={<Radio />}
                    label="PDF"
                  />
                  <FormControlLabel
                    value="excel"
                    control={<Radio />}
                    label="Excel"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4} lg={4}></Grid>

            <Grid xs={12} sm={4} md={4} item>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={[{ value: -1, label: "Custom" }].concat(Period)}
                fullWidth
                size="small"
                onChange={(event, newValue: any) => {
                  // console.log(newValue?.value);

                  if (newValue && newValue.value !== undefined) {
                    if (newValue.value === -1) {
                      formik.setFieldValue("parentId", newValue.value || null);
                    } else {
                      formik.setFieldValue("index", newValue.index || null);
                      formik.setFieldValue(
                        "startDate",
                        newValue.startDate || ""
                      );
                      formik.setFieldValue("endDate", newValue.endDate || "");
                      formik.setFieldValue(
                        "daysOnly",
                        newValue.daysOnly || false
                      );
                      formik.setFieldValue(
                        "displayLabel",
                        newValue.label || ""
                      );
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    console.error("newValue is null or undefined");
                    // Optionally reset form fields or handle the case here
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <CustomLabel text={t("text.Period")} required={false} />
                    }
                  />
                )}
              />
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <TextField
                type="date"
                id="fromDate"
                name="fromDate"
                label={
                  <CustomLabel text={t("text.FromDate")} required={false} />
                }
                value={formik.values.fromDate}
                placeholder={t("text.FromDate")}
                size="small"
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                disabled={formik.values.parentId !== -1}
                InputProps={{
                  readOnly: formik.values.parentId !== -1,
                }}
              />
            </Grid>

            {/* To Date Input */}
            <Grid xs={12} sm={4} md={4} item>
              <TextField
                type="date"
                id="toDate"
                name="toDate"
                label={<CustomLabel text={t("text.ToDate")} required={false} />}
                value={formik.values.toDate}
                placeholder={t("text.ToDate")}
                size="small"
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                disabled={formik.values.parentId !== -1}
                InputProps={{
                  readOnly: formik.values.parentId !== -1,
                }}
              />
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <CustomMultiSelectAutocomplete
                options={option}
                label={t("text.VehicleType")}
                value={option.filter(opt => vType.includes(opt.value))}
                onChange={handleVehicleTypeChange}
              />
            </Grid>

            <Grid item xs={12} sm={4} lg={4}>
              <CustomMultiSelectAutocomplete
                options={VnoOption}
                label={t("text.VehicleNos1")}
                value={VnoOption.filter(opt => vNO.includes(opt.value))}
                onChange={handleVehicleNoChange}
              />
            </Grid>

            <Grid xs={12} sm={4} md={4} item></Grid>

            <Grid xs={12} sm={4} md={4} item>
              <Button
                type="submit"
                fullWidth
                style={{
                  backgroundColor: `var(--header-background)`,
                  color: "white",
                  marginTop: "10px",
                }}
                onClick={() => {
                  const selectedPeriod = formik.values.fromDate ? formik.values.fromDate : formik.values.index;

                  if (!selectedPeriod) {

                    alert("Please select a period. or custom date");
                  } else {

                    fetchZonesData();
                    setVisible(true);
                  }
                }}
                startIcon={<VisibilityIcon />}
              >
                Show
              </Button>
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <Button
                type="button"
                fullWidth
                style={{
                  backgroundColor: `#f44336`,
                  color: "white",
                  marginTop: "10px",
                }}
                startIcon={<RefreshIcon />}
                onClick={() => {
                  formik.resetForm();
                }}
              >
                Reset
              </Button>
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <Button
                type="button"
                fullWidth
                style={{
                  backgroundColor: "#4caf50",
                  color: "white",
                  marginTop: "10px",
                }}
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
              >
                Download
              </Button>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            container
            spacing={2}
            sx={{ marginTop: "3%", justifyContent: "center" }}
          >
            {visible && (
              <Grid item xs={12} sm={12} lg={12}>
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <DataGrid
                    rows={zones}
                    columns={adjustedColumns}
                    rowSpacingType="border"
                    autoHeight
                    slots={{
                      toolbar: GridToolbar,
                    }}
                    pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                      value: size,
                      label: `${size}`,
                    }))}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 5 } },
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                    sx={{
                      border: 0,
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#42b6f5", // Header background color
                        color: "white", // Header text color
                      },
                      "& .MuiDataGrid-columnHeaderTitle": {
                        color: "white", // Header title text color
                        fontSize: '14px'
                      },
                      "& .MuiDataGrid-cell": {
                        whiteSpace: "normal", // Ensure text wraps inside the cell
                        wordWrap: "break-word", // Break words to avoid overflow
                        overflowWrap: "break-word", // Ensure long words wrap correctly
                      },
                    }}
                  />
                )}
              </Grid>
            )}
          </Grid>

          <Modal open={Shows} onClose={() => setShows(false)}>
            <Box sx={style}>
              {IsRep ? (
                <embed src={`data:application/pdf;base64,${IsRep}`} type="application/pdf" style={{ width: "100%", height: "100%" }} />
              ) : (
                <img
                  src={nopdf}
                  alt="No Preview"
                  style={{ width: "100%", height: "100%" }}
                />
              )}
            </Box>
          </Modal>
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
}